import { Component, inject, Input } from '@angular/core';
import { RdGameService } from '../../../services/games/rd-game';
import { AllStatus } from '../../../../core/services/status/all-status';
import { Downtime } from '../../../../core/services/times/downtime';
import { GameInfoService } from '../../../services/games/game-info';
import { PlayersService } from '../../../services/players/players';
import { ActivatedRoute } from '@angular/router';
import { EndGameService } from '../../../services/end/end-game';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-pass-ball',
  imports: [TranslatePipe],
  templateUrl: './pass-ball.html',
  styleUrl: './pass-ball.scss'
})
export class PassBall {
  @Input() turning: any;
  @Input() player: any;
  @Input() tmp!: boolean;

  rdUse = inject(RdGameService);
  public allStatus$ = inject(AllStatus);
  downtime = inject(Downtime);
  gameInfo = inject(GameInfoService);
  players = inject(PlayersService);
  activatedRoute = inject(ActivatedRoute);
  endGame = inject(EndGameService);
  isTransitioning = false;

  async passTheBoll(): Promise<void>{
    if(String(this.turning) !== String(this.player?.player_id) ||
      !this.allStatus$.isPassBoll ||
      !this.rdUse.connected() ||
      !this.rdUse.gameStateReady() ||
      this.isTransitioning){
      return;
    }

    const uuid = this.activatedRoute.snapshot.paramMap.get('id') as string;
    const isEndGame = this.allStatus$.isEndGame;
    this.isTransitioning = true;

    try{
      let nextPlayerId: number | undefined;
      let otherCards: any[] = [];
      if(this.players.players.length > 1){
        const result: any = await firstValueFrom(this.gameInfo.nextTurnPlayer(uuid));
        if(!result?.room){
          throw new Error(`Backend did not return the next turn for room ${uuid}`);
        }
        nextPlayerId = result.room.turning_player_id;
        if(result.room.other_cards != null && !Array.isArray(result.room.other_cards)){
          throw new Error(`Backend returned an invalid other_cards queue for room ${uuid}`);
        }
        otherCards = result.room.other_cards ?? [];
      }

      await this.rdUse.advanceTurn(
        uuid,
        isEndGame
          ? { data: this.allStatus$.playerEndData, player: this.player }
          : undefined,
        {
          expectedPlayerId: this.player.player_id,
          nextPlayerId,
          otherCards,
        },
      );

      if(isEndGame){
        this.allStatus$.isCollectionProcess = false;
        this.allStatus$.isEndGame = false;
      }

      this.allStatus$.clearNowCard();
      this.allStatus$.isPassBoll = false;
      this.allStatus$.isRollDice = true;
      this.allStatus$.isNewListVariant = true;
      this.allStatus$.txtCardInfo = '';
      this.allStatus$.setViewBlockDice(true);

      if(this.players.players.length === 1){
        this.endGame.isEndOfGame(this.player.player_id);
      }

      this.downtime.refreshTimer();
    }catch(error){
      console.error(`Failed to pass turn for room ${uuid}`, error);
    }finally{
      this.isTransitioning = false;
    }
  }
}
